<template>
  <div :class="b()">
    <div :class="b('inner')">
      <figure>
        <img
          :class="b('badge-image')"
          :src="badge.icon"
          :alt="badge.name"
        />
        <figcaption :class="b('badge-caption')">
          {{ badge.name }}
        </figcaption>
      </figure>
      <e-button
        :class="b('download')"
        :href="certificate"
        download
      >
        {{ $t('c-badge-panel.downloadButtonLabel') }}
      </e-button>
    </div>
  </div>
</template>

<script>
  import eButton from '@/elements/e-button.vue';

  /**
   * Renders a panel, displaying the given badge.
   */
  export default {
    name: 'c-badge-panel',
    components: {
      eButton,
    },

    // mixins: [],

    props: {
      /**
       * Expects a badge level definition.
       */
      badge: {
        type: Object,
        required: true,
      },

      /**
       * Expects a download link for the related certificate.
       */
      certificate: {
        type: String,
        required: true,
      },
    },
    // data() {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  .c-badge-panel {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: functions.rem(variables.$spacing--40);
    box-shadow: functions.rem(0 5px 15px 0) variables.$color-grayscale--800;

    @include mixins.media(sm) {
      margin-top: 0;
    }

    &::before {
      // Ratio keeper
      content: '';
      float: left;
      width: 0;
      height: 0;
      padding-top: 100%;
    }

    &__badge-image {
      width: functions.rem(160px);
      height: functions.rem(160px);
    }

    &__badge-caption {
      @include mixins.font(variables.$font-size--24);

      margin-top: functions.rem(variables.$spacing--15);
      color: variables.$color-primary--1;
      font-weight: variables.$font-weight--semi-bold;
      text-align: center;

      @include mixins.media(sm) {
        margin-top: functions.rem(variables.$spacing--25);
      }
    }

    &__download {
      margin-top: functions.rem(variables.$spacing--15);

      @include mixins.media(sm) {
        margin-top: functions.rem(variables.$spacing--20);
      }
    }
  }
</style>
